import React, { useEffect } from 'react';

import { ServerPortal } from '@lglp/components';
import { useDispatch } from 'react-redux';
import {
  Route,
  RouteProps,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';

import { reset } from '../actions/errors';
import { Maintenance } from '../pages/Maintenance';
import { SSRComponent } from '../types/component';

const isPopOverRoute = (routeId?: string): boolean =>
  !!(routeId && routeId !== 'FOCUS__FOCUS_POPIN' && routeId.match(/__/));

const useScrollMemory = (): void => {
  const history = useHistory();

  useEffect(() => {
    if (history.action !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [history.action, history.location.pathname]);
};

const useResetGlobalError = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(reset());
  }, [location.pathname]);
};

export const RouteLayout: SSRComponent<RouteLayoutProps> = ({ routes }) => {
  useScrollMemory();
  useResetGlobalError();

  if (process.env.RAZZLE_ENABLE_MAINTENANCE_PAGE === 'true') {
    return <Maintenance />;
  }

  return (
    <>
      <Switch>
        {routes.map(
          ({ path, id, exact, component }, idx) =>
            !isPopOverRoute(id) && (
              <Route
                key={`route-${idx}`}
                path={path}
                exact={exact}
                component={component}
              />
            )
        )}
      </Switch>

      <Switch>
        {routes.map(
          ({ path, id, exact, component }, idx) =>
            isPopOverRoute(id) && (
              <Route
                key={`popover-route-${idx}`}
                path={path}
                exact={exact}
                component={component}
              />
            )
        )}
      </Switch>

      <ServerPortal />
    </>
  );
};

RouteLayout.getInitialProps = (data): any => {
  return data;
};

type RouteWithIdProps = { id: string } & RouteProps;

interface RouteLayoutProps {
  routes: RouteWithIdProps[];
}
